import { formatDate } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DEFAULT_LOGO, USER_ROLES } from '@shared/constant/shared.constant';
import { ParkingLotOffer } from '@core/models/promo-code.modal';
import { CustomValidator, validateInput } from '@shared/services/custom-validatior.abstract';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { PromoCodeManagementService } from '@core/services/promo-code-management.service';
import { ToastService } from '@shared/services/toast.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { PaymentSucessComponent } from '../booking-flow/payment-success/payment-success.component';
import { BreadcrumbItem, CompanyService } from '@shared/services/company.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Calendar } from 'primeng/calendar';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
enum OfferVisbility {
  private = 0,
  public = 1,
}
@Component({
  selector: 'app-promo-code-management',
  templateUrl: './promo-code-management.component.html',
  styleUrls: ['./promo-code-management.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class PromoCodeManagementComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  @ViewChild('calendarTopStartDateRef') topStartDateCalendar: Calendar;
  @ViewChild('calendarTopEndDateRef') topEndDateCalendar: Calendar;
  createPromoCodeForm: FormGroup;
  currentDate: Date = new Date();
  calculatedDate: Date = this.currentDate;
  companyId: string = '';
  parkingLotsData: any[] = [];
  selectedData: any = [];
  roleName: string = '';
  bookingTypeOptions = [
    { label: 'All',value: 4 },
    { label: 'One Time', value: 3 },
    { label: 'Recurring', value: 1 },
  ];
  offerId: string = '';
  offerDetailsById: any;
  userRoles = USER_ROLES;
  isEdit: boolean = false;
  disabledHours: number[] = [];
  disabledMinutes: number[] = [];
  promoOfferData: any;
  offerVisbility = OfferVisbility;
  dummy = DEFAULT_LOGO;

  constructor(
    private readonly promoCodeApiService: PromoCodeManagementService,
    private readonly fb: FormBuilder,
    private readonly toastService: ToastService,
    private readonly SuperAdminService: SuperAdminService,
    private readonly dialogControlService: DialogControlService,
    private readonly companyService: CompanyService,
    private readonly route: ActivatedRoute,
    public readonly router : Router,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit() {
    this.roleName = this.encryptStorage.getItem('roleName');
    this.promoOfferData = history.state.offerData;
    this.isEdit = !(this.promoOfferData?.categoryView === 'Trucklots' && (this.roleName === USER_ROLES.PARKING_MANAGER || this.roleName === USER_ROLES.PARKING_OWNER));
    this.isEdit = this.router.url.includes('edit')
    this.promocodeForm();
    window.scroll(0,0);
    this.companyId = this.encryptStorage.getItem('companyId');
    this.route.params.subscribe((params) => {
      this.offerId = params['offerId'];
      if (this.offerId) {
        this.getOfferById();
      }
    });
    this.route.params.subscribe((params: Params) => {
      this.companyId = params['id'];
      const breadcrumbObj: BreadcrumbItem[] = [
        {
          title: 'Promo Codes',
          url:'super-admin/promo-codes'
        },
        {
          title: this.isEdit ? 'Edit Details' : (this.offerId ? 'View Details' : 'Create Promo Code')
        }        
      ];
      this.companyService.setAdminHeaders(this.offerId ? '0':this.companyId, breadcrumbObj);
      this.getParkingLots(this.companyId);
    });
  }
  openTopStartDateCalendar() {
    this.topStartDateCalendar.showOverlay();
    this.topStartDateCalendar.inputfieldViewChild.nativeElement.dispatchEvent(new Event('focus'))
    this.topStartDateCalendar.inputfieldViewChild.nativeElement.dispatchEvent(new Event('click'))
  }

  openTopEndDateCalendar() {
    this.topEndDateCalendar.showOverlay();
    this.topEndDateCalendar.inputfieldViewChild.nativeElement.dispatchEvent(new Event('focus'))
    this.topEndDateCalendar.inputfieldViewChild.nativeElement.dispatchEvent(new Event('click'))
  }
  promocodeForm() {
    this.createPromoCodeForm = this.fb.group({
      selectcategory: [
        null,
        this.roleName === this.userRoles.SUPER_ADMIN ? Validators.required : null,
      ],
      offerCode: ['', Validators.required],
      offerDiscount: [
        '',
        [Validators.required, CustomValidator.validateLessThanHundred],
      ],
      startDate: ['', Validators.required],
      endDate: ['', [Validators.required]],
      bookingType: ['', Validators.required],
      offerSummary: ['', [Validators.required]],
      offerDescription: ['', Validators.required],
      searchParkingLot:[''],
      offerVisibility : [ ,[Validators.required]],
      parkingLots: this.fb.array([], this.minSelectedCheckboxes(1)),
    });
    this.createPromoCodeForm
      .get('selectcategory')
      ?.valueChanges.subscribe((value) => {
        this.updateParkingLotsValidator(value);
      });
  }

  get parkingLotsArray(): FormArray {
    return this.createPromoCodeForm.get('parkingLots') as FormArray;
  }

  updateParkingLotsValidator(selectCategoryValue: boolean | null) {
    const parkingLotsControl = this.createPromoCodeForm.get('parkingLots');
    if (selectCategoryValue) {
      parkingLotsControl?.setValidators(this.minSelectedCheckboxes(1));
    } else {
      parkingLotsControl?.clearValidators();
    }
    parkingLotsControl?.updateValueAndValidity();
  }

  navigateToEditOfferEditDetails(): string {
    const basePath = this.roleName === this.userRoles.SUPER_ADMIN ? 'super-admin' : 'manager';
    const companyIdSegment = this.roleName === this.userRoles.SUPER_ADMIN ? `/${this.companyId}` : '';
    return `/${basePath}/edit-promo-code-details/${this.offerId}${companyIdSegment}`;
  }

  navigateToViewOfferEditDetails(): string {
    const basePath = this.roleName === this.userRoles.SUPER_ADMIN ? 'super-admin' : 'manager';
    const companyIdSegment = this.roleName === this.userRoles.SUPER_ADMIN ? `/${this.companyId}` : '';
    return `/${basePath}/view-promo-code-details/${this.offerId}${companyIdSegment}`;
  }

  editPromoRoute(): void {
    this.router.navigate([this.navigateToEditOfferEditDetails()]);
  }

  editPromoCode(): void {
    if (!this.validateStartAndEndDate()) {
      
      return;
    }else{
      
      const req = {
        offerId: this.offerId,
        endDate: formatDate(this.createPromoCodeForm.value.endDate, 'yyyy-MM-dd', 'en-US'),
      };
      this.SuperAdminService.modifyOfferEndDate(req)
        .pipe(
          autoUnsubWith(this.destroyRef)
        )
        .subscribe({
          next: (response) => {
            this.toastService.showToastMessage('success', 'Success', response.message);
            this.isEdit = false;
          this.disableForm(this.isEdit);
          setTimeout(() => {
            this.router.navigate([this.navigateToViewOfferEditDetails()]);
          }, 1000);
        },
        error: (_error) => {  
          this.toastService.showToastMessage('error', 'Error', _error.error.message); 
        },
      });
    }
  }

  selectOfferVisibility(value: number): void { 
    this.createPromoCodeForm.get('offerVisibility')?.setValue(value);
  }

  minSelectedCheckboxes(min = 1) {
    return (formArray: AbstractControl) => {
      const totalSelected = formArray.value.filter(
        (value: boolean) => value
      ).length;
      return totalSelected >= min ? null : { required: true };
    };
  }

  getParkingLots(id) {
      
    const searchKeyword = this.createPromoCodeForm.get('searchParkingLot')?.value || '';
    this.SuperAdminService.getParkingLotByStatesNameForOffer(id,searchKeyword)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
    .subscribe({
      next: (response) => {
        this.parkingLotsData = response;
        
        if (this.offerId) {
          this.initializeParkingLotsArray();
          this.disableForm(this.isEdit);
          if(this.offerDetailsById?.offerSpecified === 0) {
            this.checkAll(true);
          }
        } else {
          this.initializeParkingLots();
        }
      },
      error: (_error) => {
        this.disableForm(this.isEdit);
        this.parkingLotsData = [];
      },
    });
  }

  getOfferById() {
    let offerId = this.offerId;
    this.promoCodeApiService.getOfferById(offerId)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
    .subscribe({
      next: (response) => {
        this.offerDetailsById = response.data;
        if (this.offerDetailsById) {
          this.patchPromoCodeFormValues();
          let companyId = this.offerDetailsById?.parkingLots[0]?.companyId;
          this.getParkingLots(companyId);
        }
      }
    });
  }
  disableForm(isEdit: boolean) {
    if (this.isOfferId) {
      this.createPromoCodeForm.disable(); // Disable main form group
      this.parkingLotsArray.controls.forEach(control => {
        control.disable();
      });
      if (isEdit) {
        this.createPromoCodeForm.get('endDate')?.enable();
      }
    }
  }

  toUTCDate(dateString: string): Date {
    const date = new Date(dateString);
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }

patchPromoCodeFormValues() {
    const promoCodeData = {
      selectcategory: this.offerDetailsById.offerSpecified, // Example value
      offerCode: this.offerDetailsById.couponCode,
      offerDiscount: this.offerDetailsById?.percentage,
      startDate: this.toUTCDate(this.offerDetailsById.startDate),
      endDate: this.toUTCDate(this.offerDetailsById.endDate),
      bookingType: this.offerDetailsById?.couponFor,
      offerSummary: this.offerDetailsById?.summary,
      offerDescription: this.offerDetailsById?.description,
      parkingLots: this.offerDetailsById.parkingLots.map(
        (lot) => lot.parkingLotId
      ),
      offerVisibility: this.offerDetailsById?.offerVisibility,
    };

    this.createPromoCodeForm.patchValue(promoCodeData);
    this.parkingLotsArray.clear();
    this.parkingLotsData.forEach((lot) => {
      const isChecked = promoCodeData.parkingLots.includes(lot.id);
      this.parkingLotsArray.push(new FormControl(isChecked));
    });
  }
  initializeParkingLotsArray() {
    this.parkingLotsArray.clear();
    this.selectedData = [];
    this.parkingLotsData.forEach((data) => {
      const matchedLot = this.offerDetailsById?.parkingLots.find(
        (lot) => lot.parkingLotId === data.id
      );
      const isChecked = !!matchedLot;
      this.parkingLotsArray.push(this.fb.control(isChecked));
      if (isChecked) {
        this.selectedData.push({
          parkingLotId: data.id,
          companyId: data.companyId ? data.companyId : null,
        });
      }
    });
  }

  initializeParkingLots() {
    this.parkingLotsData.forEach(() => {
      this.parkingLotsArray.push(this.fb.control(false));
    });
  }

  checkAll(checked: boolean) {
    this.parkingLotsArray.controls.forEach((control) => {
      control.setValue(checked);
    });
    if (checked) {
      this.selectedData = this.parkingLotsData.map((lot) => ({
        parkingLotId: lot.id,
        companyId: lot.companyId ? lot.companyId : null,
      }));
    } else if (!checked) {
      this.selectedData = [];
    }
  }

  selectedParkingLots(data, event) {
    const index = this.parkingLotsData.indexOf(data);
    if (index > -1) {
      this.parkingLotsArray.at(index).setValue(event.checked);
      if (event.checked) {
        this.selectedData.push({
          parkingLotId: data.id,
          companyId: data.companyId ? data.companyId : null,
        });
      } else {
        this.selectedData = this.selectedData.filter(
          (item) => item.parkingLotId !== data.id
        );
      }
    }
  }

  createPromoCode() {
    
    if (this.createPromoCodeForm.valid) {
      if (!this.validateStartAndEndDate()) {
        
        return;
      }
      let request: ParkingLotOffer = {
        parkingLots:
          this.createPromoCodeForm.value.selectcategory === false
            ? null
            : this.selectedData,
        couponCode: this.createPromoCodeForm.value.offerCode,
        percentage: Number(this.createPromoCodeForm.value.offerDiscount),
        summary: this.createPromoCodeForm.value.offerSummary,
        description: this.createPromoCodeForm.value.offerDescription,
        startDate: formatDate(this.createPromoCodeForm.value.startDate, 'yyyy-MM-dd', 'en-US'),
        endDate: formatDate(this.createPromoCodeForm.value.endDate, 'yyyy-MM-dd', 'en-US'),
        offerStatus: 2,
        couponFor: this.createPromoCodeForm.value.bookingType,
        offerVisibility: this.createPromoCodeForm.value.offerVisibility,
      };

      if (this.offerId) {
        request.id = this.offerId;
      }
      const apiCall = this.offerId
        ? this.promoCodeApiService.editOffer(request)
        : this.promoCodeApiService.createPromoCode(request);
      // Handle the API response
      apiCall
        .pipe(
          autoUnsubWith(this.destroyRef)
        )
        .subscribe({
          next: (_response) => {
            this.navigateToOfferScreen();
          }
      });
    } else {
      
      this.createPromoCodeForm.markAllAsTouched();
      this.checkRequiredcategoryParkinglot();
    }
  }

  navigateToOfferScreen() {
    this.dialogControlService.openDialog(PaymentSucessComponent, {
      width: '25%',
      data: { assistedUrl: (this.roleName === this.userRoles.SUPER_ADMIN )? 'super-admin/promo-codes': 'manager/promo-codes', buttonText: "OK", bodyText: 'The promo code has been created successfully.' },
    });
  }

  validateStartAndEndDate(): boolean {
    const createAdjustedDate = (dateString: string): Date => {
      const date = new Date(dateString);
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
  
    const adjustedStartDate = createAdjustedDate(
      this.createPromoCodeForm?.value?.startDate || this.createPromoCodeForm?.getRawValue()?.startDate
    );
    const adjustedEndDate = createAdjustedDate(this.createPromoCodeForm.value.endDate);
    if (adjustedEndDate < adjustedStartDate) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        'End Date should be greater than Start Date.'
      );
      return false;
    }
    return true;
  }
  
  checkRequiredcategoryParkinglot() {
    const selectCategoryControl =
      this.createPromoCodeForm.get('selectcategory');
    const parkingLotsControl = this.createPromoCodeForm.get('parkingLots');
    switch (true) {
      case selectCategoryControl?.invalid:
        this.toastService.showToastMessage(
          'error',
          'Error',
          'Category selection is required'
        );
        break;
      case parkingLotsControl?.hasError('required'):
        this.toastService.showToastMessage(
          'error',
          'Error',
          'Mandatory fields must not be empty.'
        );
        break;
    }
  }

  selectCategory(value: boolean) {
    if(!this.offerId){
    this.createPromoCodeForm.controls['selectcategory'].setValue(value);
    }
  }  

  onOfferCodeInput(): void {
    const offerCodeControl = this.createPromoCodeForm.get('offerCode');
    if (offerCodeControl) {
      offerCodeControl.setValue(offerCodeControl.value.toUpperCase().replace(/\s+/g, ''), { emitEvent: false });
    }
  }
  onKeyPressAllowTwoDigitAfterPoint(event: KeyboardEvent): void {
    if (!validateInput(event)) {
      event.preventDefault();
    }
  }

  categoerRadioCheck(): boolean {
    if (
      this.roleName === this.userRoles.SUPER_ADMIN && !this.createPromoCodeForm.get('selectcategory').value
    ) {
      return true;
    } else {
      return false;
    }
  }
  redirectToListing(): void {
    const route = (this.roleName === this.userRoles.SUPER_ADMIN) 
      ? 'super-admin/promo-codes' 
      : 'manager/promo-codes';
    
    this.router.navigate([route]);
  }
  get isOfferId():boolean{
    return  this.offerId ? true : false;
  }

  toggleCheckbox(data: any, index: number): void {
    if(!this.offerId){
    const control = this.parkingLotsArray.at(index);
    control.setValue(!control.value);
      this.selectedParkingLots(data, { checked: control.value });
  }
}
}